import { store } from '/@/store'

export const useAppStore = defineStore('app', () => {
  const axiosProgress = ref<number | null>(null)

  function setAxiosProgress(progress: number | null) {
    axiosProgress.value = progress
  }

  return {
    axiosProgress,
    setAxiosProgress,
  }
})

export function useAppStoreWithout() {
  return useAppStore(store)
}

/**
 * Pinia supports Hot Module replacement, so you can edit your store and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
